import { Button } from "@/components/ui/button";
import { BaseSheet } from "@/components/common/BaseSheet";
import { useIsMobile } from "@/hooks/ui/useIsMobile";
import { cn } from "@/lib/utils";

type NoiseEnvironmentSheetProps = {
  open: boolean;
  brandColor: string;
  onDismiss: () => void;
  onSwitchToText: () => void;
};

export const NoiseEnvironmentSheet = ({
  open,
  brandColor,
  onDismiss,
  onSwitchToText,
}: NoiseEnvironmentSheetProps) => {
  const isMobile = useIsMobile(768);

  return (
    <BaseSheet
      isOpen={open}
      onClose={onDismiss}
      title="Too much background noise"
      description="We're picking up extra sound around you. For clearer answers, switch to text chat."
      side={isMobile ? "bottom" : "right"}
      size={isMobile ? "full" : "md"}
      showCloseButton={false}
      hideTitle={false}
      preventOutsideClick={false}
      contentClassName={cn(!isMobile && "sm:max-w-md")}
      footer={
        <div className="flex w-full flex-col gap-2 pb-[max(8px,env(safe-area-inset-bottom))]">
          <Button
            type="button"
            className="w-full border-0 text-white shadow-sm"
            style={{
              background: `linear-gradient(90deg, ${brandColor}, #FF4DB8)`,
            }}
            onClick={() => {
              onSwitchToText();
              onDismiss();
            }}
          >
            Open text chat
          </Button>
          <Button type="button" variant="outline" className="w-full border-[#E5EAF0]" onClick={onDismiss}>
            Keep voice
          </Button>
        </div>
      }
    >
      <p className="text-sm leading-relaxed text-[#7C8B9C]" role="note">
        You can keep talking or switch to typing — whichever fits your surroundings.
      </p>
    </BaseSheet>
  );
};
